//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            fromLBApp: sessionStorage.fromLBApp
        }
    },
    computed: {
        notAvailableShow: {
            get() {
                return this.$store.state.notAvailable;
            },
            set(value) {
                this.$store.state.notAvailable = value;
            }
        }
    },
    methods: {
        getFromLBApp() {
            this.fromLBApp = sessionStorage.fromLBApp;
        }
    },
    mounted() {}
}



// WEBPACK FOOTER //
// ./src/components/home/notAvailable.vue